



































import { Component, Vue, Prop } from 'vue-property-decorator';
import QRCode from 'qrcodejs2';
@Component
export default class Shares extends Vue {
  @Prop({ default: '龙艺秀' }) private title: any;
  @Prop({ default: '' }) private voteId: any;
  @Prop({ default: '' }) private questionId: any;
  @Prop({ default: '' }) private caseType: any; //  caseType类型  0：模板 1：案例
  @Prop({ default: '' }) private topicTitle: any; //  话题
  private hoverShare: any = 0; // 分享
  private showModal: any = false;
  private dialogTitle: any = '分享到微信';
  private codeUrl: any = '';
  private created() {
    if (this.voteId || this.questionId) {
      this.getWechatCode();
    }
  }
  private getWechatCode() {
    let pathUrl: any = '';
    let scene: any = '';
    if (this.voteId) {
      pathUrl = 'pages_package4/preview/home';
      scene = `voteId=${this.voteId}&hometype=${this.caseType === 0 ? 1 : this.caseType === 1 ? 2 : 1}`;
    }
    if (this.questionId) {
      pathUrl = 'pages_package3/preview/preview';
      scene = `questionId=${this.questionId}&p=1&m=1`;
    }
    this.$apis
      .getAppletCode({
        pathUrl,
        scene,
      })
      .then((res) => {
        this.codeUrl = this.$tool.getImageParam(res.qiNiuSrc);
      });
  }
  // 分享微博
  private shareWeibo() {
    console.log(window.location.href);
    let logo = this.$tool.getImageParam(`https://image.longyixiu.com/9c9d73ee8a274d73a4136325fd2b0de6`);
    if (this.$subName == 'wenjuajia') {
      logo = this.$tool.getImageParam(`https://image.longyixiu.com/19fac57cdb764e0595ac97fdd94d4a3e.png`);
    }
    const wbPageUrl = encodeURIComponent(window.location.href);
    const wbTitle = `【${this.title}】（分享自@${this.$globalName}） #${this.$globalName}# #${this.topicTitle}# `;
    const url = `https://service.weibo.com/share/share.php?url=${wbPageUrl}&title= ${encodeURIComponent(wbTitle)} &pic=${logo}`;
    // this.$router.replace(url.split('/#/')[1])
    window.open(url);
    // count=表示是否显示当前页面被分享数量(1显示)(可选，允许为空)
    // &url=将页面地址转成短域名，并显示在内容文字后面。(可选，允许为空)
    // &appkey=用于发布微博的来源显示，为空则分享的内容来源会显示来自互联网。(可选，允许为空)
    // &title=分享时所示的文字内容，为空则自动抓取分享页面的title值(可选，允许为空)
    // &pic=自定义图片地址，作为微博配图(可选，允许为空)
    // &ralateUid=转发时会@相关的微博账号(可选，允许为空)
    // &language=语言设置(zh_cn|zh_tw)(可选)
  }
  // 分享到qq空间
  private shareToRoom() {
    const wbTitle = `【${this.title}】`;
    const desc = `（分享自@${this.$globalName}） #${this.$globalName}# #${this.topicTitle}# `;
    const url = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(window.location.href)}
       &title=${encodeURIComponent(wbTitle)}&desc=${encodeURIComponent(desc)}`;
    // 跳转地址
    window.open(url);
  }
  private handleClose() {
    this.showModal = false;
  }
  private shareToWechat() {
    this.showModal = true;
    this.qrCode(window.location.href);
  }
  private qrCode(code: any) {
    this.$nextTick(() => {
      const el: any = this.$refs.shareWechatCode;
      el.innerHTML = '';
      const qrcode = new QRCode(this.$refs.shareWechatCode, {
        text: code,
        width: 300,
        height: 300,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
    });
  }
}
